<script>
	import MagnifyingGlassIllustration from 'components/svg/magnifying-glass-illustration.vue';
	import SliderIllustration from 'components/svg/slider-illustration.vue';
	import LearningIllustration from 'components/svg/learning-illustration.vue';
	import GlobeIllustration from 'components/svg/globe-illustration.vue';
	import ClipboardIllustration from 'components/svg/clipboard-illustration.vue';
	import LevelsIllustration from 'components/svg/levels-illustration.vue';
	import HighlighterIllustration from 'components/svg/highlighter-illustration.vue';
	import BookStackIllustration from 'components/svg/book-stack-illustration.vue';

	export default {
		components: {
			'magnifying-glass-illustration': MagnifyingGlassIllustration,
			'slider-illustration': SliderIllustration,
			'learning-illustration': LearningIllustration,
			'globe-illustration': GlobeIllustration,
			'clipboard-illustration': ClipboardIllustration,
			'levels-illustration': LevelsIllustration,
			'highlighter-illustration': HighlighterIllustration,
			'book-stack-illustration': BookStackIllustration
		},
		data() {
			return {
				features: [
					{
						icon: 'magnifying-glass-illustration',
						text: 'Diverse Content'
					},
					{
						icon: 'learning-illustration',
						text: 'SEL Tools'
					},
					{
						icon: 'slider-illustration',
						text: 'Audio & Text Sizing'
					},
					{
						icon: 'globe-illustration',
						text: 'ELL & SPED'
					},
					{
						icon: 'clipboard-illustration',
						text: 'Formative Assessments'
					},
					{
						icon: 'levels-illustration',
						text: 'Text Levels for Differentiation'
					},
					{
						icon: 'highlighter-illustration',
						text: 'Highlights & Annotations'
					},
					{
						icon: 'book-stack-illustration',
						text: 'Student Library'
					}
				]
			};
		}
	};
</script>
<style lang="scss">
	@import 'mixins/media';
	@import 'config/colors';

	.tools-and-features-panel {
		padding: 3rem 0;
		background: linear-gradient(151.01deg, $c-blue-accent-1 1.27%, $c-blue-dark 79.25%);

		color: $c-white;
		line-height: 1.15;

		.wrapper {
			display: flex;
			flex-direction: column;

			@include media(med) {
				flex-direction: row;
				align-items: center;
			}
		}

		.panel-info {
			text-align: center;

			@include media(med) {
				flex: 0 0 13rem;
				margin-right: 2rem;
				text-align: left;
			}

			@include media(lg) {
				flex-basis: 19rem;
				margin-right: 4rem;
			}
		}

		h2 {
			margin-top: 0;
		}

		.panel-content {
			@include media(lg) {
				font-size: 1.8rem;
			}
		}

		.features-wrapper {
			width: 100%;
			display: flex;
			flex-wrap: wrap;
			justify-content: center;

			@include media(med) {
				display: grid;
				grid-template-columns: repeat(4, 1fr);
				gap: 2rem 1rem;
			}
		}

		.feature {
			@include media(med, max) {
				margin-top: 2rem;
				flex-basis: 6.5rem;
				margin-right: 1rem;
			}
		}

		.feature-content {
			max-width: 7.5rem;
		}

		.feature-icon-container {
			padding: 1rem;
			background-color: $c-white;
			border: 1px solid $c-blue-accent-2;
			border-radius: 1.5rem;
			box-shadow: 0px 0px 10px 2px rgba($c-white, 0.42);

			@include media(lg) {
				padding: 1.5rem;
			}
		}

		.feature-icon {
			height: 100%;
		}

		.feature-text {
			margin-top: 0.5rem;
			text-align: center;

			@include media(lg) {
				font-size: 1.125rem;
			}
		}
	}
</style>
<template>
	<section class="tools-and-features-panel">
		<div class="wrapper">
			<div class="panel-info">
				<h2>Learning Tools & Features</h2>
				<div class="panel-content">Personalized and accessible features to reach every learner</div>
			</div>
			<ul class="features-wrapper list-unstyled">
				<li
					v-for="feature in features"
					:key="feature.icon"
					class="feature">
					<div class="feature-content">
						<div class="feature-icon-container">
							<component
								:is="feature.icon"
								class="feature-icon"></component>
						</div>
						<div class="feature-text">{{ feature.text }}</div>
					</div>
				</li>
			</ul>
		</div>
	</section>
</template>
